import { DecimalPipe, NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { ReviewStats } from '@shared/components/review-badge/models';
import { SvgComponent } from '@shared/components/svg';

@Component({
  selector: 'app-review-badge',
  imports: [SvgComponent, DecimalPipe, TranslatePipe, NgClass],
  templateUrl: './review-badge.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReviewBadgeComponent {
  readonly reviewStats = input.required<ReviewStats>();
  readonly forceMobileDisplay = input<boolean>(false);
}
